<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Setar Responsável
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="responsavel"
            :items="colaboradores"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Responsável"
            hide-details
            prepend-icon="person"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props: ["value", "atividade", "loading"],
  data() {
    return {
      responsavel: null
    };
  },
  methods: {
    ...mapMutations(["showNotification"]),
    adiciona() {
      if (this.responsavel) {
        if (this.atividade !== null) {
          this.atividade.IdResponsavel = this.responsavel.IdColaborador;
          this.atividade.Responsavel = this.responsavel.Descricao;
          this.$emit("setaResponsavel", this.atividade);
          this.responsavel = null;
        } else {
          this.$emit("setaResponsavelSelected", this.responsavel);
          this.responsavel = null;
        }
      } else {
        this.showNotification({ text: "Informe o responsável", status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(["colaboradores"])
  }
};
</script>

<style>
</style>
